import React, {useEffect, useState} from 'react';

import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import Chip from '@mui/material/Chip';
import LocationPinIcon from '@mui/icons-material/LocationOn';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import AddressField from '../common/AddressField';

const CurrentLocationButton = ({
  onChange,
  setError,
}) => {
  return (
    <Button
      startIcon={<LocationPinIcon />}
      color='success'
      variant='contained'
      onClick={(e) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            onChange(e, {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            });
          },
          err => setError(new Error(`There was an error getting your location: ${err.message}`)),
        );
      }}
    >
      Use My Current Location
    </Button>
  );
};

const PatientSchedulingLocationForm = ({
  onSubmit,
  stepNum = 1,
  defaultValue = null,
  subtitle = 'Find providers nearby',
}) => {
  const [error, setError] = useState(null);
  const [address, setAddress] = useState(defaultValue);
  const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
  return (
    <Box style={{width: '100%'}}>
      <Stack spacing={4} alignItems='left' width='100%'>
        {/* <Avatar
          variant='rounded'
          style={{backgroundColor: config().colors.primary}}
          sx={{width: 56, height: 56}}
        >
          <LocationPinIcon />
        </Avatar> */}
        <Stack spacing={0.5} alignItems='left'>
          <Typography variant='h2'>Choose Your Location</Typography>
          <Typography>{subtitle}</Typography>
        </Stack>
        {!!error && 
          <Alert severity='error'>
            {error.message || 'There was an error getting your location'}
          </Alert>
        }
        <Stack spacing={1} alignItems='center'>
          {usingCurrentLocation 
            ? <Chip 
              icon={<CheckIcon color='success'/>} 
              label="Near Your Current Location" 
              onDelete={() => {
                setUsingCurrentLocation(false);
                setAddress(null);
              }}
            />
            : !address && <CurrentLocationButton 
                setError={setError}
                onChange={(e, {lat, lon}) => {
                  setUsingCurrentLocation(true);
                  setAddress({lat, lon});
                }}
              />
          }
          {!usingCurrentLocation && !address &&
            <Typography variant='subtitle'>OR</Typography>
          }
          <Box style={{width: '100%', maxWidth: '350px', minWidth: '300px'}}>
            {!usingCurrentLocation && 
              <AddressField 
                editable={false}
                fullWidth
                showAddress={false}
                size='large'
                placeholder='Enter an address'
                useGeocoding={true}
                onChange={(e, data) => {
                  console.log('E', e, data);
                  setUsingCurrentLocation(false);
                  if (data) {
                    setAddress(data);
                  } else if (e.address_line_1) {
                    setAddress(e);
                  } else {
                    setAddress(e?.target?.value);
                  }
                }}
                onSubmit={(e, data) => {
                  console.log('onSubmit', e, data);
                  if (data) {
                    setAddress(data);
                  } else if (e.address_line_1) {
                    setAddress(e);
                  } else {
                    setAddress(e?.target?.value);
                  }
                }}
              />
            }
          </Box>
          <Button 
            variant='contained' 
            size='large'
            fullWidth
            maxWidth='350px'
            disabled={!address}
            onClick={e => onSubmit(e, address)}
          >
            Continue
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PatientSchedulingLocationForm;